module.exports = __webpack_public_path__ + "static/media/clock.1be621d5.svg";